let IdNamePair = require('./IdNamePair');

module.exports = class NaughtyScore extends IdNamePair {};
